import {styled} from '@mui/material/styles'
import {Backdrop, Button} from '@mui/material'

export const StyledBackdrop = styled(Backdrop)(({theme}) => ({
  color: theme.palette.primary.main,
  zIndex: theme.zIndex.drawer + 1
}))

export const StyledDiv = styled('div')(({theme}) => ({
  padding: '24px'
}))

export const StyledBackButton = styled(Button)(({theme}) => ({
  fontSize: '14px',
  color: theme.palette.common.grey,
  padding: 0
}))
